import section2zxdt from '../../images/section2zxdt.png'
import React, { Component } from 'react';
import './ReactCarousel.scss';
import section2_2 from '../../images/section2_2.png'
import zhanlue from '../../images/zhanlue.jpg'
import Bgbutton from '../Bgbutton/Bgbutton'
import medicalServiceCompanies from '../../images/medical-service-companies.jpg'
import umerBg from '../../images/umer-bg.jpg'
class ReactCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [
                {
                    img: 'https://test-cdn.youmaiyisheng.com/umer-doctor/20260529/10925424_507_1780045443765_1780045443765_1.jpg',
                    desc: '官宣丨优麦医生成为国际特应性皮炎学会（ISAD）中国独家战略合作伙伴',
                    href: '/latestdevelopments22'
                },
                {
                    img: 'https://test-cdn.youmaiyisheng.com/umer-doctor/20260529/10925424_938_1780045451762_1780045451762_2.jpg',
                    desc: '优麦医生@AAD2026，高城回眸',
                    href: '/latestdevelopments23'
                },
                {
                    img: 'https://test-cdn.youmaiyisheng.com/umer-doctor/20260529/10925424_912_1780045458719_1780045458719_3.jpg',
                    desc: '优麦科技成立10周年 | 创业之路，听创始人说',
                    href: '/latestdevelopments24'
                },
                {
                    img: 'https://test-cdn.youmaiyisheng.com/umer-doctor/20260529/10925424_808_1780045465526_1780045465526_4.jpg',
                    desc: '优麦医生十周年庆典暨第七届皮肤科在线教育卓越影响力颁奖盛典举行',
                    href: '/latestdevelopments25'
                }
            ],
            showIndex: 0, //显示第几个图片
            timer: null,  // 定时器
            show: false   // 前后按钮显示
        }
    }
    render() {
        return (
            <div className="ReactCarousel">
                <div className="contain"
                    onMouseEnter={() => { this.stop() }} //鼠标进入停止自动播放
                    onMouseLeave={() => { this.start() }}  //鼠标退出自动播放
                >
                    <ul className="ul">
                        {
                            this.state.data.map((value, index) => {
                                return (
                                    <li className={index === this.state.showIndex ? 'show' : ''}
                                        key={index}
                                    >
                                        <img src={value.img} alt="轮播图" />
                                    </li>
                                )
                            })
                        }
                    </ul>

                </div>
                <div className='section2div'>
                    <div>
                        <img className='section2tabimg' src={section2zxdt} alt="" />
                        <div>
                            {

                                <div>
                                    <div className='section2divs'>

                                        {this.state.data[this.state.showIndex].desc}

                                    </div>
                                </div>
                            }
                        </div>
                        <div>
                            <ul className="dots">
                                {
                                    this.state.data.map((value, index) => {
                                        return (
                                            <li key={index}
                                                className={index === this.state.showIndex ? 'active' : ''}
                                                onClick={() => { this.change(index) }}>
                                            </li>)
                                    })
                                }
                            </ul>
                            <div className='section2img'>
                                {
                                    <div>
                                        <div className='section2divs'>

                                            {<Bgbutton txt='查看详情' href={this.state.data[this.state.showIndex].href}></Bgbutton>}

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
    componentDidMount() { //一开始自动播放
        this.start();
    }
    componentWillUnmount() { //销毁前清除定时器
        this.stop();
    }
    stop = () => { //暂停
        let { timer } = this.state;
        clearInterval(timer);
    }
    start = () => { //开始
        let { timer } = this.state;
        timer = setInterval(() => {
            this.next();
        }, 5000);
        this.setState({
            timer
        })
    }
    change = (index) => { //点击下面的按钮切换当前显示的图片
        let { showIndex } = this.state;
        showIndex = index;
        this.setState({
            showIndex
        })
    }
    previous = (e) => { //上一张
        let { showIndex, data } = this.state;
        if (showIndex <= 0) {
            showIndex = data.length - 1;
        } else {
            showIndex--;
        }
        this.setState({
            showIndex
        })
    }
    next = (e) => { //下一张
        let { showIndex, data } = this.state;
        if (showIndex >= data.length - 1) {
            showIndex = 0;
        } else {
            showIndex++;
        }
        this.setState({
            showIndex
        })
    }
}
export default ReactCarousel;